// @ts-nocheck
import { rfqQuoteDetailsQuotedPricingStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuotedPricing";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(rfqQuoteDetailsQuotedPricingStyles, {
    row: {
        evenRowCss: css`
            background: transparent;
        `,
        css: css`
            display: flex;
            flex-direction: column;
            + tr {
                margin-top: ${pxToRem(10)};
            }
        `,
    },
    quantityCell: {
        css: css`
            border: none;
            height: initial;
            vertical-align: top;
            padding: 0;
        `,
    },
    priceCell: {
        css: css`
            border: none;
            height: initial;
            padding: 0;
        `,
    },
});
